var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('cuentas-table',{attrs:{"cedula":_vm.cedula},on:{"update:nomitaTransaccionTableConfig":_vm.onUpdateNtTable}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }